document.addEventListener("DOMContentLoaded", app);

function app() {

  allSliders();
  otherModels();
  headerSticky();
  showMore();
  carTabs();
  scrollNav();
  timerBlock();
  burgerMenu();
  maskPhone();
  copiedLinks();
  allCityes();
  calcFilter();
  headerHeight();
  carImageResize();

}

function headerHeight() {
  var header = document.querySelector('.header');
  var headerInsideOut = document.querySelector('.header_inside_out');

  if (headerInsideOut) {
    headerInsideOut.style.height = header.offsetHeight + 'px';
  }
}


function carImageResize() {
  const sliderIm = document.querySelector('.topcar_image_slider_im');
  if (!sliderIm) {
    return;
  }

  const { width, height, top } = sliderIm.getBoundingClientRect();
  
  const topcar = document.querySelector('.topcar');
  if (!topcar) {
    return;
  }
  
  const topcarTop = topcar.getBoundingClientRect().top;
  const relativeTop = top - topcarTop;
  
  const images = document.querySelectorAll('.topcar_slider_img--car img');
  if (images.length === 0) {
    return;
  }

  images.forEach(img => {
    img.style.width = `${width}px`;
    img.style.height = `${height}px`;
    img.style.position = 'relative';
    img.style.top = `${relativeTop}px`;
  });
}



// --- слайдеры ---
function allSliders() {
  // первый экран
  const sliderElement = document.querySelector('.first_swiper');
  if (sliderElement) {
    const swiper = new Swiper('.first_swiper', {
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.first_pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.first_btn_next',
        prevEl: '.first_btn_prev',
      },
    });

    const inputs = document.querySelectorAll('.first_swiper input');
    inputs.forEach(input => {
      input.addEventListener('focus', () => {
        swiper.autoplay.stop();
        console.log('стоп');
      });
      input.addEventListener('blur', () => {
        swiper.autoplay.start();
        console.log('старт');
      });
    });

  }

    // преимущества
  const sliderElement2 = document.querySelector('.pluses_swiper');
  if (sliderElement2) {
    const swiper2 = new Swiper('.pluses_swiper', {
        slidesPerView: 1,
        spaceBetween: 8,

        pagination: {
          el: '.pluses_slider_pagination',
          clickable: true,
        },

        navigation: {
          nextEl: '.pluses_btn_next',
          prevEl: '.pluses_btn_prev',
        },

        breakpoints: {
          480: {
            slidesPerView: 1,
            spaceBetween: 32,
          },
        }
    });
  }

    // галерея
  const sliderElement3 = document.querySelector('.gallery_swiper');
  if (sliderElement3) {
    const swiper3 = new Swiper('.gallery_swiper', {
      loop: true,
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 24,

      pagination: {
        el: '.gallery_slider_pagination',
        clickable: true,
      },

      navigation: {
        nextEl: '.gallery_slider_arrows_next',
        prevEl: '.gallery_slider_arrows_prev',
      },
    });
  }

    // шаги
  const sliderElement4 = document.querySelector('.steps_swiper');
  if (sliderElement4) {
    const swiper4 = new Swiper('.steps_swiper', {
      slidesPerView: 1,
      spaceBetween: 8,

      pagination: {
        el: '.steps_slider_pagination',
        clickable: true,
      },

      navigation: {
        nextEl: '.steps_btn_next',
        prevEl: '.steps_btn_prev',
      },

      breakpoints: {
        480: {
          slidesPerView: 1,
          spaceBetween: 32,
        },
      }
    });
  }

    // галереи
  const sliderElement5 = document.querySelector('.models_item_img_slider');
  if (sliderElement5) {
    const swiper5 = new Swiper('.models_item_img_slider', {
      loop: true,
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 24,
      slidesPerView: 1,

      pagination: {
        el: '.models_item_img_slider_pagination',
        clickable: true,
      },

      navigation: {
        nextEl: '.models_item_img_slider_arrows_next',
        prevEl: '.models_item_img_slider_arrows_prev',
      },
    });
  }

  // внутренняя страница модель
  const sliderElemen6 = document.querySelector('.topcar_slider_st');
  if (sliderElemen6) {
    const swiper6 = new Swiper('.topcar_slider_st', {
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
      },

      pagination: {
        el: '.topcar_slider_pagination',
        clickable: true,
      },

      navigation: {
        nextEl: '.topcar_slider_arrows_next',
        prevEl: '.topcar_slider_arrows_prev',
      },
    });

    function toggleTopcarBg() {
      setTimeout(() => {
        const activeSlide = document.querySelector('.swiper-slide-active');
        const topcarElement = document.querySelector('.topcar');
    
        if (activeSlide && topcarElement) {
          if (activeSlide.classList.contains('topcar_slider_img--bg')) {
            topcarElement.classList.add('topcar--bg');
            topcarElement.classList.remove('topcar--car');
          } else {
            topcarElement.classList.remove('topcar--bg');
            topcarElement.classList.add('topcar--car');
          }
        }
      }, 0);
    }
    
    swiper6.on('slideChange', function () {
      toggleTopcarBg();
    });
    
    toggleTopcarBg();
    
  }
    

    // внутренняя другие модели
  const sliderElement7 = document.querySelector('.cars_listing_slider');
  if (sliderElement7) {
    const swiper7 = new Swiper('.cars_listing_slider', {
      slidesPerView: 1,
      spaceBetween: 32,

      pagination: {
        el: '.cars_listing_slider_pagination',
        clickable: true,
      },

      navigation: {
        nextEl: '.cars_listing_slider_arrows_next',
        prevEl: '.cars_listing_slider_arrows_prev',
      },

      breakpoints: {
        980: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
      }
    });
  }
}

// внутренняя другие модели
function otherModels() {
  const swiperModElements = document.querySelectorAll('.swiper-wrapper-mod');

  if (swiperModElements.length > 0) {
    if (window.innerWidth <= 768) {
      swiperModElements.forEach(element => {
        element.classList.add('swiper-wrapper');
        element.classList.remove('row');
      });

      const swiper8 = new Swiper('.imgtxt_slider', {
        slidesPerView: 1,
        spaceBetween: 32,
      });

    } else {
      swiperModElements.forEach(element => {
        element.classList.add('row');
        element.classList.remove('swiper-wrapper');
      });
    }
  }
}

// --- закрепление шапки ---
function headerSticky() {
  toggleHeaderClass();

  window.addEventListener("scroll", function() {
      toggleHeaderClass();
  });

  function toggleHeaderClass() {
      var header = document.querySelector('.header');
      if (window.scrollY >= 300) {
          header.classList.add('header_sticky');
      } else {
          header.classList.remove('header_sticky');
      }
  }
}


function showMore() {
  var content = document.getElementById('content_wr');
  var button = document.getElementById('content_wr_btn');

  if (content != null) {
    if (content.offsetHeight > 150) {
      content.classList.add('content_wr_limited');
      button.style.display = 'block';

      button.addEventListener('click', function() {
        content.classList.toggle('content_wr_limited');

        if (content.classList.contains('content_wr_limited')) {
            button.textContent = 'Показать больше';
        } else {
            button.textContent = 'Показать меньше';
        }
      });
    } else {
      button.style.display = 'none';
    }
  }
}



// --- табы авто ---
function carTabs() {
  var tabs = document.querySelectorAll('.cars_nav_item');
  var contents = document.querySelectorAll('.cars_listing');

  if (tabs.length === 0 || contents.length === 0) {
    return;
  }

  tabs.forEach(function(tab) {
      tab.addEventListener('click', function(event) {
          event.preventDefault();

          tabs.forEach(t => t.classList.remove('active'));
          contents.forEach(c => c.classList.remove('active'));

          contents.forEach(c => c.classList.add('inactive'));

          tab.classList.add('active');

          var targetId = tab.getAttribute('data-target');
          var activeTabContent = document.querySelector(`.cars_listing[data-id="${targetId}"]`);
          if (activeTabContent) {
              activeTabContent.classList.remove('inactive');
              activeTabContent.classList.add('active');
          }
      });
  });
}


// --- прокрутка навигации ---
function scrollNav() {
  var el = document.querySelector('.cars_nav');
  var isDown = false;
  var startX;
  var scrollLeft;

  if (el != null) {
    el.addEventListener('mousedown', function(e) {
        isDown = true;
        el.classList.add('active');
        startX = e.pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
    });

    el.addEventListener('mouseleave', function() {
        isDown = false;
        el.classList.remove('active');
    });

    el.addEventListener('mouseup', function() {
        isDown = false;
        el.classList.remove('active');
    });

    el.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - el.offsetLeft;
        var walk = (x - startX) * 2;
        el.scrollLeft = scrollLeft - walk;
    });
  }
}

// --- таймер обратного отсчета ---
function timerBlock() {
  const timerBlock = document.querySelector('.timer_timer_it');
  if (timerBlock == null) {
    return;
  }

  var mode = 'week'; // Установить нужный режим можно здесь 'month', 'week', 'day'

  // Функция для вычисления времени окончания в зависимости от режима
  function getEndTime(mode) {
      var now = new Date();
      switch (mode) {
          case 'month':
              return new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
          case 'week':
              var day = now.getDay() || 7; // Воскресенье = 7
              return new Date(now.getFullYear(), now.getMonth(), now.getDate() + (7 - day), 23, 59, 59);
          case 'day':
              return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
          default:
              return new Date();
      }
  }

  // Получаем ширину любого .timer_timer_item_numb и задаем эту ширину всем .timer_timer_item_numb
  function setTimerItemWidth() {
      const timerItemNumb = document.querySelector('.timer_timer_item_numb');
      if (timerItemNumb) {
          const width = timerItemNumb.offsetWidth;
          console.log('Ширина:', width);
          console.log('Содержимое:', timerItemNumb.innerHTML);
          const allTimerItemNumbs = document.querySelectorAll('.timer_timer_item_numb');
          allTimerItemNumbs.forEach(item => {
              item.style.width = width + 'px';
          });
      }
  }

  // Устанавливаем ширину и затем запускаем таймер
  setTimerItemWidth();

  // Функция для вычисления времени окончания текущего месяца
  function getEndOfMonth() {
      var now = new Date();
      return new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
  }

  // Функция для добавления ведущего нуля
  function pad(num) {
      return num < 10 ? '0' + num : num;
  }

  // Функции для склонения единиц времени
  function declOfNum(number, titles) {
      var cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
  }

  // Функция для обновления таймера
  function updateTimer(endTime) {
      var now = new Date();
      var remaining = endTime - now;

      if (remaining <= 0) {
          clearInterval(timerInterval);
          remaining = 0;
      }

      // Конвертируем время из миллисекунд в дни, часы, минуты, секунды
      var days = Math.floor(remaining / (1000 * 60 * 60 * 24));
      var hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      // Обновляем HTML
      document.querySelector('.timer_timer_days').textContent = pad(days);
      document.querySelector('.timer_timer_hours').textContent = pad(hours);
      document.querySelector('.timer_timer_min').textContent = pad(minutes);
      document.querySelector('.timer_timer_sec').textContent = pad(seconds);

      // Обновляем склонения
      document.querySelector('.timer_timer_days_txt').textContent = declOfNum(days, ['день', 'дня', 'дней']);
      document.querySelector('.timer_timer_hours_txt').textContent = declOfNum(hours, ['час', 'часа', 'часов']);
      document.querySelector('.timer_timer_min_txt').textContent = declOfNum(minutes, ['минута', 'минуты', 'минут']);
      document.querySelector('.timer_timer_sec_txt').textContent = declOfNum(seconds, ['секунд', 'секунд', 'секунд']);
  }

  var endTime = getEndTime(mode);
  updateTimer(endTime); // Первоначальное обновление таймера

  var timerInterval = setInterval(function() {
      updateTimer(endTime);
  }, 1000); // Обновление каждую секунду для оптимизации производительности
}

// --- бургер меню ---
function burgerMenu() {
  const burgerMenu = document.querySelector('.burger_menu');
  const header = document.querySelector('.header');
  const body = document.body;
  const navLinks = document.querySelectorAll('.header_nav_item_link'); 
  if(burgerMenu != null) {
    function closeMenu() {
        burgerMenu.classList.remove('open');
        header.classList.remove('open');
        body.classList.remove('hidden');
    }
    
    burgerMenu.addEventListener('click', function() {
        burgerMenu.classList.toggle('open');
        header.classList.toggle('open');
        body.classList.toggle('hidden');
    });
    
    navLinks.forEach(link => {
        link.addEventListener('click', closeMenu);
    });
  }
}

// --- маска телефона ---
function maskPhone() {
  var eventCallback = function (e) {
      var el = e.target,
          clearVal = el.dataset.phoneClear,
          pattern = el.dataset.phonePattern,
          matrix_def = "+7 (___) ___-__-__",
          matrix = pattern ? pattern : matrix_def,
          i = 0,
          def = matrix.replace(/\D/g, ""),
          val = e.target.value.replace(/\D/g, "");

      // запрещаем ввод более 8 одинаковых цифр
      function hasMoreThanEightSameDigits(value) {
          var digitCounts = Array(10).fill(0);
          for (var digit of value) {
              digitCounts[digit]++;
              if (digitCounts[digit] > 8) {
                  return true;
              }
          }
          return false;
      }

      if (hasMoreThanEightSameDigits(val)) {
          e.target.value = e.target.value.slice(0, -1);
          return;
      }

      if (clearVal !== 'false' && e.type === 'blur') {
          if (val.length < matrix.match(/([\_\d])/g).length) {
              e.target.value = '';
              return;
          }
      }
      if (def.length >= val.length) val = def;
      e.target.value = matrix.replace(/./g, function (a) {
          return /[_\d]/.test(a) && i < val.length ? val.charAt(i++) : i >= val.length ? "" : a;
      });
  }

  var phone_inputs = document.querySelectorAll('input[name="phone"]');
  for (let elem of phone_inputs) {
      for (let ev of ['input', 'blur', 'focus']) {
          elem.addEventListener(ev, eventCallback);
      }
  }
}

// --- копирование ссылок ---
function copiedLinks() {
  var elements = document.querySelectorAll('[data-copy-link]');
  if (elements != null) {
    elements.forEach(function (element) {
      element.addEventListener('click', function (event) {
        event.preventDefault();

        var copyLinkValue = element.getAttribute('data-copy-link');

        navigator.clipboard.writeText(copyLinkValue).then(function () {
          element.classList.add('copyed');

          setTimeout(function () {
            element.classList.remove('copyed');
          }, 3000);
        }).catch(function (err) {
          console.error('Не удалось скопировать значение:', err);
        });
      });
    });
  }
}

// Фильтр
function calcFilter() {
  let rangeElements = document.querySelectorAll('.calc_content_nav_item_cont_range input[type="range"]');
  let contItems = document.querySelectorAll('.calc_content_cont_item');

  rangeElements.forEach(function(range) {
      let type = range.name.split('-')[0]; // price, first, srok
      let minValues = Array.from(contItems, function(item) {
          return parseInt(item.getAttribute('data-filter-' + type)) || Infinity;
      });
      let min = Math.min.apply(null, minValues);
      range.min = min;
      range.value = min;

      updateResult(type, min);
  });

  function updateResult(type, value) {
    let result = document.getElementById(type + '-numb');
    result.textContent = new Intl.NumberFormat('ru-RU').format(value);
  }

  document.addEventListener('input', function(e) {
    if (e.target.matches('.calc_content_nav_item_cont_range input[type="range"]')) {
        let type = e.target.name.split('-')[0]; // price, first, srok
        updateResult(type, e.target.value);

        updateFilters();
    }
  });

  function updateFilters() {
    let rangeValues = {
        price: parseInt(document.getElementById('price-range').value),
        first: parseInt(document.getElementById('first-range').value),
        srok: parseInt(document.getElementById('srok-range').value)
    };

    let contItems = document.querySelectorAll('.calc_content_cont_item');
    contItems.forEach(function(item) {
        let isMatch = ['price', 'first', 'srok'].every(function(type) {
            let filterValue = parseInt(item.getAttribute('data-filter-' + type)) || 0;
            return filterValue <= rangeValues[type];
        });

        if (isMatch) {
            item.classList.remove('noactive');
        } else {
            item.classList.add('noactive');
        }
    });
  }
}

// Города
function allCityes() {
  function handleCityItems() {
      const cityesWrap = document.querySelector('.cityes_wrap');
      const cityesItems = cityesWrap.querySelectorAll('.cityes_item');
      const btnShowMore = document.querySelector('.cityes_wrap_btn');

      function toggleItemsVisibility(showAll = false) {
          cityesItems.forEach((item, index) => {
              item.style.display = (showAll || index < 20) ? '' : 'none';
          });
      }

      if (cityesItems.length > 20) {
          toggleItemsVisibility();
          btnShowMore.style.display = 'block';
      }

      btnShowMore.addEventListener('click', () => {
          toggleItemsVisibility(true);
          btnShowMore.style.display = 'none';
      });
  }

  if (window.matchMedia('(max-width: 767.98px)').matches) {
      handleCityItems();
  }
}


// --- лайтбоксы/фансибокс ---
Fancybox.bind("[data-fancybox]", {
});